<template>
  <section id="home" class="section">
    <div class="container-wrap" id="profile_ripple">
      <h1 class="entry-title-sub" data-jarallax-element="0 30">Hola, Soy</h1>
      <h1 class="entry-title jarallax-title" data-jarallax-element="0 50">
        <br />
        <br />
        <span>Elis Daza E</span>
      </h1>

      <img
        class="main-photo block-right jarallax-home"
        data-jarallax-element="0 -30"
        src="@/assets/mrdaza.jpg"
        alt="Elis Daza"
      />
      <a href="#services" class="main-btn slow-scroll">
        Conocerme
        <svg class="stroke-primary main-btn slow-scroll" width="42" height="42">
          <path d='M7.71178 17.2976L24.7944 35.5602L41.877 17.2976' style="stroke-width:8"/>
        </svg>
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: "page-home",
  data() {
    return {
      msn: "Pagína de Home"
    };
  }
};
</script>
